<template>
	<div class="page-404 h-screen flex">
		<div class="w-full h-screen flex justify-center items-center">
			<div>
				<p class="text-8xl text-center text-blue-500 font-bold">404</p>
				<p class="text-xl">Упс, {{ resource }} не существует.</p>
				<router-link
					class="block text-white text-lg text-center bg-gradient-to-r from-cyan-500 to-blue-500 rounded-lg px-2 py-4 mt-6"
					:to="{ name: 'home' }"
				>
					На главную
				</router-link>
			</div>
		</div>
		<div class="w-full h-screen bg-red-500 overflow-hidden">
			<img
				class="object-cover object-center h-full"
				src="https://images.unsplash.com/photo-1541870730196-cd1efcbf5649?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=872&q=80"
				alt="Image 404"
			/>
		</div>
		<!-- <h1>Упс, {{ resource }} не существует.</h1>
		<p>Скорее всего вы перешли по неправильной ссылке.</p>
		<router-link class="home-link" :to="{ name: 'home' }">
			На главную
		</router-link> -->
	</div>
</template>

<script>
export default {
	name: 'PageNotFound',
	props: {
		resource: {
			type: String,
			required: true,
			default: 'страницы',
		},
	},
};
</script>

<style scoped>
/* .page-404 {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	min-height: 80vh;
}

.home-link {
	margin: 2rem 0;
	font-weight: 700;
	font-size: 2rem;
	color: #36429e;
} */
</style>
